import herald_responsive_nav_open from '../functions/herald_responsive_nav_open';
import herald_responsive_nav_close from '../functions/herald_responsive_nav_close';
import herald_center from "./herald_center";

export default function() {
    herald_center();

    $('.main-navigation').on('mouseenter', 'li', function (e) {
        if ($(this).closest('body').width() < $(document).width()) {
            $(this).find('ul').addClass('herald-rev');
        }
    });

    imagesLoaded( '.herald-header-sticky', function() {
        $('.herald-header-sticky .hel-el').children().each(function () {
            $(this).heraldCenter().animate({
                opacity: 1
            }, 100);
        });
    });

    imagesLoaded( '.header-bottom', function() {
        $('.header-bottom .hel-el').children().each(function () {
            $(this).heraldCenter().animate({
                opacity: 1
            }, 100);
        });
    });

    $('body').on('mouseenter', '.herald-site-header .herald-mega-menu, .herald-header-sticky .herald-mega-menu', function () {
        var el_width = $('.herald-site-content').width();
        $(this).find('> .sub-menu').css('width', el_width + 'px');
    }).on('click', '.herald-subcat-dropdown', function () {
        $(this).find('.herald-mod-subnav-mobile').slideToggle(200);
    }).on('click', 'i.fa-bars', function () {
        if($(".herald-site-content").hasClass('open')) {
            $('.herald-slide').removeClass('open');
            $('body').removeClass('herald-menu-open');
        } else {
            $(".herald-slide").removeClass('close').addClass('open');
            $('body').addClass('herald-menu-open');
        }
    }).on('click', '.herald-site-content', function () {
        if ($('.herald-site-content').hasClass('open')) {
            herald_responsive_nav_close();
        }
    });

    if (window.matchMedia("(max-width: 766px)").matches) {
        $('.herald-mod-subnav-mobile').each(function () {
            $(this).closest('.herald-mod-h').addClass('herald-subcat-dropdown');
        });
    }

    if (herald_js_settings.header_sticky) {
        var herald_last_top;
        $(window).scroll(function () {
            var top = $(window).scrollTop();
            if (herald_js_settings.header_sticky_up) {
                if (herald_last_top > top && top >= herald_js_settings.header_sticky_offset) {
                    $("body").addClass("herald-sticky-header-visible");
                } else {
                    $("body").removeClass("herald-sticky-header-visible");
                }
            } else {
                if (top >= herald_js_settings.header_sticky_offset) {
                    $("body").addClass("herald-sticky-header-visible");
                } else {
                    $("body").removeClass("herald-sticky-header-visible");
                }
            }
            herald_last_top = top;
        });
    }

    if (herald_js_settings.responsive_menu_more_link != 0) {
        var mobile_nav = $('.herald-more-link-wrapper');
        var secondary = $('.herald-mobile-nav .secondary-navigation');
        if (secondary.length) {
            secondary.each(function () {
                var menu = $(this).find('ul').first().children();
                mobile_nav.find('.herald-more-link ul').append(menu);
                $(this).remove();
            });
        }
    }

    $('.herald-nav-toggle').on('click', function () {
        if ($('.herald-site-content').hasClass('open')) {
            herald_responsive_nav_close();
        } else {
            herald_responsive_nav_open();
        }
    });

    $('.herald-mobile-nav li').each(function () {
        var $this = $(this);
        $this.closest('nav').removeClass('herald-menu').addClass('herald-mob-nav');
        if ($this.hasClass('menu-item-has-children') || $this.hasClass('herald-mega-menu')) {
            $this.append('<span class="herald-menu-toggler fa fa-caret-down"></span>');
        }
        if ($this.hasClass('herald-mega-menu')) {
            var sub_categories = $this.find('.herald-mega-menu-sub-cats ul li');
            $this.find('.container').remove();
            $this.find('.sub-menu').append(sub_categories);
        }
    });

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        $('.herald-menu-toggler').on('touchstart', function (e) {
            $(this).prev().slideToggle();
            $(this).parent().toggleClass('herald-current-mobile-item');
        });
    } else {
        $('.herald-menu-toggler').on('click', function (e) {
            $(this).prev().slideToggle();
            $(this).parent().toggleClass('herald-current-mobile-item');
        });
    }
}
